import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Confirmation dialog shown before permanently deleting a lead. Isolated
 * from AdminLeads.jsx so the delete confirmation flow is self-contained.
 */
export const DeleteLeadDialog = ({ lead, deleting, onCancel, onConfirm }) => (
  <AlertDialog open={Boolean(lead)} onOpenChange={(open) => !open && onCancel()}>
    <AlertDialogContent className="bg-white" data-testid="admin-delete-lead-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this consultation request?</AlertDialogTitle>
        <AlertDialogDescription>
          This will permanently remove {lead?.full_name}&apos;s request ({lead?.email}) from the leads dashboard. This action cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="admin-delete-lead-cancel">Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          disabled={deleting}
          className="bg-red-600 hover:bg-red-700 focus-visible:ring-red-600"
          data-testid="admin-delete-lead-confirm"
        >
          {deleting ? (
            <span className="flex items-center gap-1.5"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Deleting...</span>
          ) : (
            "Delete request"
          )}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
